import { graphql, type Environment } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';

import {
    type nftPublicProfileEditMutation as NftPublicProfileEditMutation,
    type PublicProfileEditInput,
    type nftPublicProfileEditMutation$data,
} from './__generated__/nftPublicProfileEditMutation.graphql.ts';

const mutation = graphql`
    mutation nftPublicProfileEditMutation($input: PublicProfileEditInput!) {
        publicProfileEdit(input: $input) {
            publicProfile {
                ...NftPublicProfileEditForm_publicProfile
            }
            errorReason
        }
    }
`;

type MutationParams = {
    environment: Environment;
    input: PublicProfileEditInput;
};

export const nftPublicProfileEditMutation = async ({
    environment,
    input,
}: MutationParams): Promise<nftPublicProfileEditMutation$data> => {
    const result = await commitMutation<NftPublicProfileEditMutation>(environment, {
        mutation,
        variables: {
            input,
        },
    });

    return result;
};
